/**
 * Tooltip error messages for verification status display.
 * Used only when building tooltip text; does not affect existing logic.
 */
export enum TooltipError {
  INVALID_ZIP = 'Invalid ZIP code',
  INVALID_STATE = 'Invalid state',
  INVALID_CITY = 'Invalid city',
  INVALID_STREET = 'Invalid street address',
  INVALID_ROUTING = 'Invalid routing number',
  INVALID_ACCOUNT = 'Invalid bank account',
  ACCOUNT_NOT_VERIFIED = 'Account number could not be verified',
  OWNERSHIP_NOT_VERIFIED = 'Account ownership could not be verified',
  POSSIBLE_SANCTION_MATCH = 'Possible sanctions list match',
  SANCTION_MATCH = 'Sanctions match detected',
  GENERIC_ADDRESS = 'Address corrected',
  GENERIC_BANK = 'Bank verification failed',
}
